import numeral from "numeral";

export default function formatCurrency(values: {
  amount: number;
  currency: string;
}) {
  // TODO: Take currency into account
  return values?.amount === undefined ? null : numeral(values.amount / 100);
}
